import React from "react";
import TextLoopAnimation from "../../LoopTextHelper/TextLoopAnimation";
import styles from "../AnimationTexts/animationsTexts.module.scss";

const AnimationTexts = () => {
  const texts = [
    {
      title: "Sarkari Kaam",
      color: "#FFAD32",
    },
    {
      title: "Mobile Tricks",
      color: "#6F4CFE",
    },
    {
      title: "Online Earning",
      color: "#03CA0A",
    },
    {
      title: " Youtube",
      color: "#FFAD32",
    },
    {
      title: "Business Growth",
      color: "#EF5A2B",
    },
    {
      title: "Share Market",
      color: "#1BE8CF",
    },
  ];
  return (
    <div>
      <div className={styles.introduction}>
        <div className={styles.hero_section_animation}>
          <div className={styles.hero_text_section}>
            <div className={styles.hero_text}>
              <h1 className={styles.hero_text_h1_title}>Seekho</h1>
              <div className={styles.hero_text_content}>
                <TextLoopAnimation
                  type={"landing"}
                  windowSize={[]}
                  texts={texts}
                  loopInterval={2000}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimationTexts;
